<template>
    <el-popover
            placement="bottom"
            trigger="click"
            :visible-arrow="false"
            @hide="onHide"
            @show="onShow">
        <template #reference>
            <div class="th-filter-down">
                <i :class="['el-icon-arrow-down', iconActive ? 'el-icon-arrow-down-active' : '']"></i>
            </div>
        </template>

        <template>
            <div class="multiselect-container">
                <el-input class="input-filter" v-model="topicInputFilter" :placeholder="$t('btn_search')" prefix-icon="el-icon-search" clearable></el-input>
                <div class="selectall-row">
                    <span class="selectall-item" @click="selectAll">{{ $t('select_all') }}</span>
                    <span class="selectall-item" @click="unSelectAll">{{ $t('unselect_all') }}</span>
                </div>
                <el-checkbox-group v-model="valueHere">
                    <div class="group-check">
                        <el-checkbox
                            class="group-check-checkbox"
                            v-for="(v, k) in optionsHere"
                            :key="k"
                            :label="v[valueKey] || ''">
                            <span class="checkbox-text">
                                <el-tooltip :content="v[labelKey] || ''" :disabled="v[labelKey].length < 13">
                                    <span class="text">{{ v[labelKey] || ''}}</span>
                                </el-tooltip>
                                <span class="input-row" v-show="v.showDayOverDue && valueHere.includes('5')">
                                    <el-input class="input-row-input" v-model="dayOverDueHere[0]" :placeholder="$t('few_days_later')" size="mini"></el-input>
                                    <span class="ri">~</span>
                                    <el-input class="input-row-input" v-model="dayOverDueHere[1]" :placeholder="$t('few_days_later')" size="mini"></el-input>
                                </span>
                                <span class="input-row" v-show="v.showDaysUntilDue && valueHere.includes('6')">
                                    <el-input class="input-row-input" v-model="daysUntilDueHere[0]" :placeholder="$t('Overdue_days')" size="mini"></el-input>
                                    <span class="ri">~</span>
                                    <el-input class="input-row-input" v-model="daysUntilDueHere[1]" :placeholder="$t('Overdue_days')" size="mini"></el-input>
                                </span>
                            </span>
                        </el-checkbox>
                    </div>
                </el-checkbox-group>
            </div>
        </template>
    </el-popover>
</template>
<script>
export default {
    name: 'MultiSelectPopover',
    props: {
        options: {
            type: Array,
            default: () => []
        },
        hidePopperSearch: Function,
        initPopperData: Function,//针对初次打开弹窗，动态获取数据的情况
        inputFilterKey: {
            type: Array,
            default: ['value']
        },
        value: [],
        valueKey: {
            type: String,
            default: 'value'
        },
        labelKey: {
            type: String,
            default: 'label'
        },
        dayOverDue: {
            type: Array,
            default: () => ['', '']
        },
        daysUntilDue: {
            type: Array,
            default: () => ['', '']
        },
        iconColor: {
            type: String,
            default: '#3879eb'
        },
        iconSize: {
            type: String|Number,
            default: '13'
        }
    },
    data() { return {
        topicInputFilter: '',
        valueHere: [],
        dayOverDueHere: ['', ''],
        daysUntilDueHere: ['', '']
    }},
    computed: {
        optionsHere() {
            return this.options.filter(v => {
                return this.inputFilterKey.some(vv => {
                    return v[vv] && `${v[vv]}`.toLowerCase().indexOf(this.topicInputFilter.toLowerCase()) > -1
                })
            }).map((v, k) => {
                if (['空', 'Empty'].includes(v[this.labelKey]) || v[this.labelKey].indexOf('空') > -1) {
                    v.sort = -99999
                } else {
                    v.sort = k
                }
                return v
            }).sort((a, b) => a.sort - b.sort)
        },
        iconActive() {
            return (this.valueHere && this.valueHere.length > 0) || this.dayOverDueHere.some(v => v !== '') || this.daysUntilDueHere.some(v => v !== '')
        }
    },
    methods: {
        onShow() {
            if(this.options.length<1) {
                this.initPopperData && this.initPopperData()
            }
            this.$forceUpdate()
        },
        onHide() {
            //  
            // if (this.dayOverDueHere[0] > 0 && this.dayOverDueHere[1] > 0 && (this.dayOverDueHere[0] - 0) > (this.dayOverDueHere[1] - 0)) {
            //     this.$message.error(this.$t('few_days_later_input_disallow'))
            //     this.dayOverDueHere[0] = ''
            //     this.dayOverDueHere[1] = ''
            //     return
            // }

            // if (this.daysUntilDueHere[0] > 0 && this.daysUntilDueHere[1] > 0 && (this.daysUntilDueHere[0] - 0) > (this.daysUntilDueHere[1] - 0)) {
            //     this.$message.error(this.$t('few_days_later_input_disallow'))
            //     this.daysUntilDueHere[0] = ''
            //     this.daysUntilDueHere[1] = ''
            //     return
            // }

            this.hidePopperSearch && this.hidePopperSearch()
        },
        selectAll() {
            this.valueHere = this.optionsHere.map(v => v[this.valueKey])
        },
        unSelectAll() {
            this.valueHere = []
        }
    },
    watch: {
        value(v) {
            this.valueHere = v
        },
        valueHere(v, ov) {
            this.$emit('update:value', v)
            if (this.optionsHere.some(v => v.showDayOverDue) && ov.includes('5') && !v.includes('5')) {
                this.dayOverDueHere[0] = ''
                this.dayOverDueHere[1] = ''
            }
            if (this.optionsHere.some(v => v.showDaysUntilDue) && ov.includes('6') && !v.includes('6')) {
                this.daysUntilDueHere[0] = ''
                this.daysUntilDueHere[1] = ''
            }
        },
        dayOverDueHere: {
            deep: true,
            handler(v) {
                this.$emit('update:dayOverDue', v)
            }
        },
        dayOverDue: {
            deep: true,
            handler(v) {
                this.dayOverDueHere = v
            }
        },
        daysUntilDue: {
            deep: true,
            handler(v) {
                this.daysUntilDueHere = v
            }
        },
        daysUntilDueHere: {
            deep: true,
            handler(v) {
                this.$emit('update:daysUntilDue', v)
            }
        },
    }
}
</script>
<style scoped>
.multiselect-container {
    display: flex;
    flex-direction: column;
    max-width: 100vw;
    max-height: 50vh;
    overflow-x: hidden;
    overflow-y: scroll;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.multiselect-container::-webkit-scrollbar { width: 0!important }
.multiselect-container { -ms-overflow-style: none; }
.multiselect-container { overflow: -moz-scrollbars-none; }

/* .th-filter-down {
    display: flex;
    flex-direction: row;
    align-items: center;
} */

.multiselect-container .input-filter {}
.multiselect-container .selectall-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    margin: 10px 0;
}
.multiselect-container .selectall-row .selectall-item {
    color: #409eff;
    margin-left: 10px;
    cursor: pointer;
}
.multiselect-container .group-check {
    width: 100%;
    display: flex;
    flex-direction: column;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

}
.multiselect-container .group-check .group-check-checkbox {
    width: 100%;
    margin-bottom: 12px;
}
.multiselect-container .group-check .group-check-checkbox .checkbox-text {
    margin-left: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 20px;
}
.multiselect-container .group-check .group-check-checkbox .checkbox-text .input-row {
    margin-left: 20px;
    margin-top: 5px;
}
.multiselect-container .group-check .group-check-checkbox .checkbox-text .input-row .ri {
    margin: 0 10px;
}
.multiselect-container .group-check .group-check-checkbox .checkbox-text .input-row .input-row-input {
    width: 100px;
}
.multiselect-container .group-check .group-check-checkbox .text {
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
